export var MoonPayTransactionStatus;
(function (MoonPayTransactionStatus) {
    MoonPayTransactionStatus["WAITING_PAYMENT"] = "waitingPayment";
    MoonPayTransactionStatus["PENDING"] = "pending";
    MoonPayTransactionStatus["WAITING_AUTHORIZATION"] = "waitingAuthorization";
    MoonPayTransactionStatus["FAILED"] = "failed";
    MoonPayTransactionStatus["COMPLETED"] = "completed";
})(MoonPayTransactionStatus || (MoonPayTransactionStatus = {}));
//# sourceMappingURL=types.js.map